function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Helper from '@ember/component/helper';
import { bucketFor, watchFor } from './../utils/ref';
import { registerDestructor, unregisterDestructor } from '@ember/destroyable';
import { getOwner } from '@ember/application';
export default class RefToHelper extends Helper {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_watcher", null);
  }
  compute([name], {
    bucket,
    tracked
  }) {
    const bucketRef = bucket || getOwner(this);
    if (this._name !== name) {
      if (this._watcher) {
        unregisterDestructor(this, this._watcher);
      }
      this._watcher = watchFor(name, bucketRef, () => {
        this.recompute();
      });
      registerDestructor(this, this._watcher);
      this._name = name;
    }
    if (tracked) {
      return bucketFor(bucketRef).getTracked(name);
    } else {
      return bucketFor(bucketRef).get(name);
    }
  }
}